import { useQuery } from 'react-query';
import { getUserPreferences, type UserPreferencesResponse } from '../../services/userService';

export function useGetUserPreferences(options?: { enabled?: boolean }) {
  return useQuery<UserPreferencesResponse>(['userPreferences'], getUserPreferences, {
    enabled: options?.enabled ?? true,
    staleTime: 60 * 1000,
    cacheTime: 5 * 60 * 1000
  });
}
